import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { EntitlementsProvider } from "./lib/entitlements";
import LockGate from "./components/LockGate";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PublicJoin from "./pages/PublicJoin";
import DashboardLayout from "./pages/DashboardLayout";
import OnboardPage from "./pages/OnboardPage";
import DashWaitlist from "./pages/DashWaitlist";
import DashOrders from "./pages/DashOrders";
import DashMenu from "./pages/DashMenu";
import DashSettings from "./pages/DashSettings";
import DashAnalytics from "./pages/DashAnalytics";
import DashSchedule from "./pages/DashSchedule";
import DashVoice from "./pages/DashVoice";
import DashFeedback from "./pages/DashFeedback";
import Directory from "./pages/Directory";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import BetaGuide from "./pages/BetaGuide";
import DashGoLive from "./pages/DashGoLive";
import EmbedPage from "./pages/EmbedPage";
import LogoShowcase from "./pages/LogoShowcase";
import FAQ from "./pages/FAQ";
import Troubleshooting from "./pages/Troubleshooting";
import DashAdmin from "./pages/DashAdmin";
import DashA2PWizard from "./pages/DashA2PWizard";
import DashMimiTraining from "./pages/DashMimiTraining";
import TwilioSetup from "./pages/TwilioSetup";
import Trust from "./pages/Trust";
import AdminCustomers from "./pages/AdminCustomers";
import AdminInbox from "./pages/AdminInbox";
import AdminBetaApplications from "./pages/AdminBetaApplications";
import DesignPreview from "./pages/DesignPreview";

const Protected = ({ children }) => {
  const { business, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#5C6B61]">Loading…</div>;
  if (!business) return <Navigate to="/login" replace />;
  return children;
};

export default function App() {
  return (
    <div className="App">
      <LockGate>
      <BrowserRouter>
        <AuthProvider>
          <EntitlementsProvider>
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot" element={<ForgotPassword />} />
              <Route path="/reset" element={<ResetPassword />} />
              <Route path="/join/:slug" element={<PublicJoin />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/beta-guide" element={<BetaGuide />} />
              <Route path="/embed/:slug" element={<EmbedPage />} />
              <Route path="/logo" element={<LogoShowcase />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/onboard" element={<OnboardPage />} />
              <Route path="/troubleshooting" element={<Troubleshooting />} />
              <Route path="/trust" element={<Trust />} />
              <Route path="/admin/customers" element={<AdminCustomers />} />
              <Route path="/admin/inbox" element={<AdminInbox />} />
              <Route path="/admin/beta" element={<AdminBetaApplications />} />
              <Route path="/help/twilio-setup" element={<TwilioSetup />} />
              <Route path="/preview/designs" element={<DesignPreview />} />
              <Route path="/dashboard" element={<Protected><DashboardLayout /></Protected>}>
                <Route index element={<DashWaitlist />} />
                <Route path="mimi" element={<DashMimiTraining />} />
                <Route path="orders" element={<DashOrders />} />
                <Route path="menu" element={<DashMenu />} />
                <Route path="schedule" element={<DashSchedule />} />
                <Route path="voice" element={<DashVoice />} />
                <Route path="a2p" element={<DashA2PWizard />} />
                <Route path="settings" element={<DashSettings />} />
                <Route path="admin" element={<DashAdmin />} />
                <Route path="analytics" element={<DashAnalytics />} />
                <Route path="feedback" element={<DashFeedback />} />
                <Route path="go-live" element={<DashGoLive />} />
              </Route>
            </Routes>
          </EntitlementsProvider>
        </AuthProvider>
      </BrowserRouter>
    </LockGate>
    </div>
  );
}
